import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    modalOpen: false,
    modalMessage: null,
    modalTitle: null,
    modalCallbackFunc: null,

    modalOnCloseCallbackFunc: null,
    showOk: true,
    showClose: true,
    displayFirstFitFlag: false,
};

const globalSlice = createSlice({
    name: 'global',
    initialState,
    reducers: {
        openModal: (state, action) => {
            state.modalOpen = true;
            state.modalMessage = action.payload.modalMessage || '';
            state.modalTitle = action.payload.modalTitle || '';
            state.modalCallbackFunc = action.payload?.modalCallbackFunc || null;
            state.modalOnCloseCallbackFunc = action.payload?.modalOnCloseCallbackFunc || null;
            state.showOk = action.payload?.showOk ?? state.showOk;
            state.showClose = action.payload?.showClose ?? state.showClose;
        },
        closeModal: (state) => {
            state.modalOpen = false;
            state.modalMessage = null;
            state.modalTitle = null;
            state.modalCallbackFunc = null;
            state.modalOnCloseCallbackFunc = null;
            state.showOk = true;
            state.showClose = true;
        },
        /**
         * Updates the first-fit display flag.
         */
        setDisplayFirstFitFlag: (state, action) => {
            state.displayFirstFitFlag = action.payload;
        },
    },
});

export const { openModal, closeModal, setDisplayFirstFitFlag } = globalSlice.actions;

export const globalReducer = globalSlice.reducer;
